import { Route, Routes, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/Pages/Home';
import About from './components/Pages/About';
import Contact from './components/Pages/Contact';
import { useEffect } from 'react';
import ErrorPage from './components/Pages/ErrorPage';
import PrivacyPolicy from './components/Pages/PrivacyPolicy';
import FaqPage from './components/Pages/Faq';
import Terms from './components/Pages/Terms';
import Services from './components/Pages/Services';
import Resources from './components/Pages/Blog';
import ResourceDetails from './components/Pages/BlogDetails';
import LatestNews from './components/Pages/LatestNews';

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="faq" element={<FaqPage />} />
        <Route path="privacy" element={<PrivacyPolicy />} />
        <Route path="terms" element={<Terms />} />
        <Route path="contact" element={<Contact />} />
        <Route path="services" element={<Services />} />
        <Route path="news" element={<Resources />} />
        <Route path="news/:blogId" element={<ResourceDetails />} /> 
        <Route path="latest-news" element={<LatestNews />} /> 
       

      </Route>
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
}

export default App;
